import { PayTypes, Schedule } from './payroll';

export class AuditAction {
  ActionId: number;
  UserId: string;
  Activity: string;
  Data: Record<string, string>;
  RecordedOn: Date;
}

export interface EmployeeEditRecord {
  ChangedBy: string;
  DateChanged: string;
  ClientCode: string;
  PersonId: number;
  EmployeeNumber: number;
  PersonName: string;
  ActivityType: string;
  FieldNameChanged: string;
  OldValue: string;
  NewValue: string;
}
export interface ITaskEventData {
  Id: number;
  ClientCode: string;
}

export interface IEmployeeEventData {
  ClientCode: string;
  PersonId: number;
  EmployeeName: string;
  EmployeeNumber: number;
}

export interface IPayrollEventData {
  ClientCode: string;
  LocationId: number;
  PayDate: Date | string;
  PayrollType: PayTypes;
  Calendars: Schedule[];
  SequenceNumber?: number;
  PaylineId?: number;
  PersonId?: number;
  PayrollId?: number;
}

export enum LogLevels {
  Informational = 0,
  Debug = 1,
  Warning = 2
}
